"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index74.js");var t=e.isObject,i=String,n=TypeError,o=function(r){if(t(r))return r;throw new n(i(r)+" is not an object")};exports.anObject=o;
